import styled from "styled-components";

export const DropdownsContainer = styled.div`
  position: relative;
  border: 1px solid #2c2c2c;
  border-radius: 99px;
  width: 100%;
  max-width: 250px;
  @media (max-width: 768px) {
    border: 0;
    border-radius: 0px;
    padding: 6px 0;
    max-width: 53px;
  }
`;
interface DropdownsInputProps {
  display: string;
  color: string;
}

interface DropdownItemColorsProps {
  color: string;
}

export const DropdownsInput = styled.div<DropdownsInputProps>`
  padding: 5px;
  display: flex;
  align-items: center;
  width: 100%;
  color: #2c2c2c;
  overflow: hidden;
  gap: 10px;
  user-select: none;
  @media (max-width: 768px) {
    max-width: 53px;
    padding: 0px 0px 0px 2px;
    gap: 4px;
    align-items: start;
    flex-direction: column;
  }
  &::before {
    content: "";
    display: ${(props) => props.display};
    min-width: 18px;
    height: 18px;
    margin: 0 3px;
    border: 0.5px dashed rgba(0, 0, 0, 0.5);
    background: ${({ color }) => color};
    opacity: 0.6;
    @media (max-width: 768px) {
      margin: 0px;
      min-width: 100%;
      height: 8px;
    }
  }
`;
export const Hr = styled.hr`
  margin: 5px 0;
`;
export const DropdownsInputContainer = styled.div`
  display: flex;
  align-items: center;
`;
export const Pre = styled.pre`
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
    @media (max-width: 768px) {
    font-size: 10px;
  }
`;
export const DropdownItem = styled.pre`
  padding: 5px;
  cursor: pointer;
  width: 85%;
  font-size: 1rem;
  color: #444444;
  user-select: none;
  border-radius: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  &:hover {
    transition: all 0.2s;
    box-shadow: 0px 0px 4px black;
    background: #f4f6f8;
  }
  @media (max-width: 768px) {
     font-size: 16px;
  }  
`;
export const DropdownsIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;
export const DropdownsWrapper = styled.div`
  display: flex;
  align-items: center;
`;
export const DropdownItemColors = styled.div<DropdownItemColorsProps>`
  margin: 0 8px;
  width: 25px;
  height: 6px;
  border: 0.5px dashed rgba(0, 0, 0, 0.5);
  background: ${({ color }) => color};

  &:first-child {
    opacity: 0.6;
  }
  @media (max-width: 768px) {
    width: 12px;
    height: 12px;
  }
`;
export const DropdownOptions = styled.div`
  @media (min-width: 769px) {
    width: 100%;
  position: absolute;
  padding: 4px 0;
  transform: translateY(4px);
  border: 1px solid #2c2c2c;
  border-radius: 14px;
  color: #2c2c2c;
  overflow: auto;
  background: #F4F6F8;
  max-height: 150px;
  z-index: 999;
  }  
`;

export const TitleModal = styled.h2`
text-align: center;
font-size: 18px;
margin-bottom: 10px;
`
